import tailwindUtils from "./tailwind-utils";

const lg = tailwindUtils.getMQValue("lg");

export default {
    setAriaHiddenOnDesktop(element) {
        const isDesktop = window.matchMedia("(min-width:" + lg + "px)").matches;

        if (isDesktop) {
            element.setAttribute("aria-hidden", "true");
            element.setAttribute("tabindex", "-1");
        } else {
            element.setAttribute("aria-hidden", "false");
            element.removeAttribute("tabindex")
        }
    },

    setAriaExpanded(element) {
        const isExpanded = element.getAttribute("aria-expanded") === "true";
        element.setAttribute("aria-expanded", String(!isExpanded));
    },

    setAriaLive(element) {
        element.setAttribute("aria-live", "polite");
    },
}